<div class="app-page">
  <app-header></app-header>

  <div class="app-content">
    <router-outlet></router-outlet>
  </div>

  <div class="footer">
    <p>Copyright (c) 2020 - {{ date }}</p>
  </div>
</div>
